import { FunctionComponent, useEffect } from "react";
import useRouterContext from "../hooks/useRouterContext";

interface Props {
  href: string;
  replace?: boolean;
}

const Redirect: FunctionComponent<Props> = ({ href, replace = true }) => {
  const { history } = useRouterContext();

  useEffect(() => {
    if (replace) {
      history.replace(href);
    } else {
      history.push(href);
    }
  }, [history, href, replace]);

  return null;
};

export default Redirect;
